export default "__VITE_ASSET__B9dJ_e2v__"